import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, Typography, CircularProgress, FormGroup, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem, Chip } from "@material-ui/core";
import * as Yup from "yup";
import Autocomplete from "@material-ui/lab/Autocomplete";

const styles = theme => ({
    root: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submitButton: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },
    submit: {},
    logo: {}
});

const CustomerErasureMethodForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations, supportedClientTypes } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Key"
                                value={values.Key}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Key && touched.Key)}
                                placeholder={translations["key"] || "Key"}
                                label={translations["key"] || "Key"}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <FormGroup>
                                <FormControlLabel control={
                                    <Checkbox
                                        color="primary"
                                        margin={"dense"}
                                        name={"Visible"}
                                        checked={values.Visible}
                                        onChange={handleChange}
                                    />
                                }
                                    label={`${translations["visible"] || "Visible"} (Default value: ${values.OriginalVisible})`}
                                />
                            </FormGroup>
                            <TextField
                                name="LongName"
                                value={values.LongName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LongName && touched.LongName)}
                                placeholder={translations["long_name"] || "Long name"}
                                label={`${translations["long_name"] || "Long name"} (Default value: ${values.OriginalLongName})`}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ShortName"
                                value={values.ShortName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ShortName && touched.ShortName)}
                                placeholder={translations["short_name"] || "Short name"}
                                label={`${translations["short_name"] || "Short name"} (Default value: ${values.OriginalShortName})`}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <Autocomplete
                                name={'SupportedClientTypes'}
                                disabled={true}
                                multiple
                                id="SupportedClientTypesMultiSelect"
                                options={supportedClientTypes || []}
                                getOptionLabel={(option) => option.label}
                                filterSelectedOptions
                                value={values.SupportedClientTypes}
                                onChange={(_, value) => setFieldValue('SupportedClientTypes', value)}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={`${translations["valid_for"] || "Valid for"}`} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["dedicated_for"] || "Dedicated for"}</InputLabel>
                                <Select
                                    name="DedicatedFor"
                                    disabled={true}
                                    label={translations["dedicated_for"] || "Dedicated for"}
                                    margin={"dense"}
                                    value={values.DedicatedFor}
                                    onChange={handleChange}
                                >
                                    <MenuItem key={"all"} value={"all"}>
                                        {translations['all'] || 'All'}
                                    </MenuItem>
                                    <MenuItem key={"magnetic"} value={"magnetic"}>
                                        {translations['magnetic'] || 'Magnetic'}
                                    </MenuItem>
                                    <MenuItem key={"flash"} value={"flash"}>
                                        {translations['flash'] || 'Flash'}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                name="Description"
                                disabled={true}
                                value={values.Description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Description && touched.Description)}
                                placeholder={translations["info_text"] || "Info text"}
                                label={translations["info_text"] || "Info text"}
                                margin={"dense"}
                                fullWidth={true}
                                multiline
                                rows={4}
                            />
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submitButton}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {(isSubmitting) ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(CustomerErasureMethodForm);
